import {useState} from 'react';

const useSoopiControl = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [info, setInfo] = useState({
    broadType: 'LIVE',
    broadUrl: '',
    streamerName: '',
    data: {},
  });

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleChangeInfo = (newInfo) => {
    setInfo({...newInfo});
  };

  return {
    isOpen,
    handleOpen,
    handleClose,
    info,
    handleChangeInfo,
  };
};

export default useSoopiControl;
